import React, { useState, useRef, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Col, Modal, Row } from 'react-bootstrap';
import ReactStars from 'react-stars';
import SignatureCanvas from 'react-signature-canvas';
import { BsArrowCounterclockwise } from 'react-icons/bs';
import { formatShortDate } from '../../../utils/helpers';
import { authenticatedFetch } from '../../../utils/api';

export const SignoffModal = ({ showModal, onHide, rowdata, emailAddress, deviceinfo, setLoading, settingsValues, Updatelineitem, openQueryForm }) => {
    const [showDisclaimerModal, setShowDisclaimerModal] = useState(false);
    const [signoffdata, setsignoffdata] = useState([]);
    const sigRef = useRef();

    const signOffDataIntialstate = useMemo(() => ({
        LineID: null,
        BookingReference: null,
        EmailAddress: emailAddress,
        SignOffMeta: deviceinfo,
        SignOffDate: null,
        SignOffBy: null,
        SignOffSignature: null,
        Comments: null,
        Rating: null
    }), [rowdata]);

    useEffect(() => {
        setsignoffdata(signOffDataIntialstate);
    }, [rowdata]);

    // Composite signature onto a white background so the exported image isn't transparent
    const handleSignatureEnd = () => {
        const canvas = sigRef.current.getCanvas();
        const tempCanvas = document.createElement('canvas');
        const ctx = tempCanvas.getContext('2d');
        tempCanvas.width = canvas.width;
        tempCanvas.height = canvas.height;
        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
        ctx.drawImage(canvas, 0, 0);
        const data = tempCanvas.toDataURL();
        updateFormvalues('SignOffSignature', data);
    };

    const updateFormvalues = (key, value) => {
        setsignoffdata(prevState => ({
            ...prevState,
            [key]: value
        }));
    };

    const handleReturnToMainModal = () => {
        setShowDisclaimerModal(false);
    };

    const handleShowDisclaimerModal = () => {
        updateFormvalues('LineID', rowdata.lineId);
        setShowDisclaimerModal(true);
    };

    const handleCloseDisclaimerModal = () => setShowDisclaimerModal(false);

    const handleConfirmDisclaimer = async () => {
        setShowDisclaimerModal(false);
        onHide();

        try {
            var res = await authenticatedFetch('/ManagerReport/Updatemangersignoff', {
                method: 'POST',
                body: JSON.stringify(signoffdata)
            });
            const response = await res.json();
            if (response.statusCode !== 200) {
                setLoading(false);
                window.alert(response.value);
            }
            else {
                setLoading(false);
                Updatelineitem(signoffdata.LineID, signoffdata.Rating, signoffdata.SignOffSignature);
            }
        }
        catch (ex) {
            console.log(ex);
            setLoading(false);
        }
    };

    const clearSignature = () => {
        sigRef.current.clear();
        updateFormvalues('SignOffSignature', null);
    };

    return (
        <>
            <Modal show={showModal} onHide={onHide} onExited={() => requestAnimationFrame(() => window.dispatchEvent(new Event('resize')))}>
                <Modal.Header closeButton closeVariant='white'>
                    <Modal.Title>Approve/Challenge Cost</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form style={{ width: '100%' }}>
                        <Row className="align-items-center mb-4">
                            <Col md={12} lg={6}>
                                <div className="small text-white">
                                    <p><strong className="text-color">Site Name:</strong> {rowdata.site}</p>
                                    <p><strong className="text-color">Date of Job:</strong> {formatShortDate(rowdata.jobdate)}</p>
                                    <p><strong className="text-color">Date Received:</strong> {formatShortDate(rowdata.jobdate)}</p>
                                    <p><strong className="text-color">Provider Name:</strong> {rowdata.provider}</p>
                                </div>
                            </Col>
                            <Col md={12} lg={6}>
                                <div className="small text-white">
                                    <p><strong className="text-color">Role:</strong> {rowdata.role}</p>
                                    <p><strong className="text-color">Hours:</strong> {rowdata.hours}</p>
                                    <p><strong className="text-color">Nett Cost:</strong> &pound;{rowdata.nettCost}</p>
                                    <p><strong className="text-color">Notes:</strong> {rowdata.notes}</p>
                                </div>
                            </Col>
                        </Row>
                        <hr />
                        <Button variant="success w-100 mb-3" onClick={() => openQueryForm(rowdata)}>Challenge Cost</Button>
                        <Form.Group className="mb-3">
                            <Form.Label>Rating</Form.Label>
                            <ReactStars
                                count={5}
                                onChange={(ratingvalue) => updateFormvalues('Rating', ratingvalue)}
                                value={signoffdata.Rating ?? rowdata.rating}
                                size={17}
                                half={false}
                                color2="#ffc107"
                                color1="#999"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Feedback</Form.Label>
                            <Form.Control as="textarea" rows={3} value={signoffdata.Comments ?? ""}
                                onChange={(e) => updateFormvalues('Comments', e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3 w-100">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                                <Form.Label className="mb-0">Signature</Form.Label>
                                <Button onClick={clearSignature} title="Clear signature" className="btn btn-outline p-0"
                                    style={{
                                        backgroundColor: "none",
                                        color: "white"
                                    }}><BsArrowCounterclockwise /></Button>
                            </div>
                            <div className="border p-2 signature-canvas"
                                style={{ backgroundColor: 'white', borderRadius: "6px", height: "150px" }}>
                                <SignatureCanvas
                                    penColor="black"
                                    canvasProps={{
                                        className: 'signatureCanvas'
                                    }}
                                    ref={sigRef}
                                    onEnd={handleSignatureEnd}
                                />
                            </div>
                        </Form.Group>
                        <Row className="mb-3">
                            <Col>
                                <Button variant="danger w-100" onClick={() => onHide()}>Cancel</Button>
                            </Col>
                            <Col className="text-right">
                                <Button variant="success w-100" onClick={handleShowDisclaimerModal}>Approve</Button>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>
            <Modal show={showDisclaimerModal} onHide={handleCloseDisclaimerModal} size="lg" onExited={() => requestAnimationFrame(() => window.dispatchEvent(new Event('resize')))}>
                <Modal.Header closeButton closeVariant='white'>
                    <Modal.Title>Disclaimer</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{settingsValues.ManagerApprovalDisclaimer || 'By confirming, you approve this cost entry.'}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleReturnToMainModal}>NO</Button>
                    <Button variant="primary" onClick={handleConfirmDisclaimer}>YES</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

SignoffModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    rowdata: PropTypes.object.isRequired,
    emailAddress: PropTypes.string.isRequired,
    deviceinfo: PropTypes.string,
    setLoading: PropTypes.func.isRequired,
    settingsValues: PropTypes.object.isRequired,
    Updatelineitem: PropTypes.func.isRequired,
    openQueryForm: PropTypes.func.isRequired,
};

export default SignoffModal;
